import React from "react";
import {
  formatOccupancyStatusDe,
} from "../../../utils/unitOccupancyStatus";
import { getRoomOccBadgeTone } from "./unitDetailHelpers";
import Badge from "./Badge";

export default function UnitRoomModal({
  isOpen,
  editingRoomId,
  nextRoomId,
  unitRooms,
  roomForm,
  roomModalDerivedOcc,
  onClose,
  onChange,
  onSubmit,
}) {
  if (!isOpen) return null;
  return (
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50">
            <div className="bg-white dark:bg-[#141824] w-full max-w-3xl rounded-2xl shadow-xl border border-black/10 dark:border-white/[0.07] p-6 max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h3 className="text-2xl font-bold text-[#eef2ff]">
                    {editingRoomId
                      ? "Room bearbeiten"
                      : "Neuen Room hinzufügen"}
                  </h3>
                  <p className="text-[#6b7a9a] mt-1">
                    {editingRoomId
                      ? "Bearbeite hier den vorhandenen Room."
                      : "Room ID wird automatisch vergeben."}
                  </p>
                </div>

                <button
                  onClick={onClose}
                  className="text-[#6b7a9a] hover:text-[#eef2ff] text-2xl leading-none"
                >
                  ×
                </button>
              </div>

              <div className="mb-6 bg-slate-100 dark:bg-[#111520] border border-black/10 dark:border-white/[0.07] rounded-xl p-4">
                <p className="text-[10px] text-[#64748b] dark:text-[#6b7a9a]">
                  {editingRoomId ? "Room ID" : "Automatische Room ID"}
                </p>
                <p className="text-xl font-bold text-[#eef2ff] mt-1">
                  {editingRoomId
                    ? unitRooms.find(
                        (room) => String(room.id) === String(editingRoomId)
                      )?.roomId
                    : nextRoomId}
                </p>
              </div>

              <form onSubmit={onSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm text-[#6b7a9a] mb-2">
                      Zimmername
                    </label>
                    <input
                      type="text"
                      name="roomName"
                      value={roomForm.roomName}
                      onChange={onChange}
                      required
                      className="w-full border border-black/10 dark:border-white/[0.08] rounded-[8px] px-4 py-3 bg-slate-100 dark:bg-[#111520] text-[#0f172a] dark:text-[#eef2ff] outline-none focus:ring-2 focus:ring-[#7aaeff]/40"
                    />
                  </div>

                  <div>
                    <label className="block text-sm text-[#6b7a9a] mb-2">
                      Fläche (m²)
                    </label>
                    <input
                      type="number"
                      name="sizeM2"
                      value={roomForm.sizeM2}
                      onChange={onChange}
                      min="0"
                      step="0.01"
                      placeholder="z. B. 18"
                      className="w-full border border-black/10 dark:border-white/[0.08] rounded-[8px] px-4 py-3 bg-slate-100 dark:bg-[#111520] text-[#0f172a] dark:text-[#eef2ff] outline-none focus:ring-2 focus:ring-[#7aaeff]/40"
                    />
                    <p className="text-xs text-[#6b7a9a] mt-1">
                      Wird für Mietvertrag und Zimmerangaben verwendet.
                    </p>
                  </div>

                  <div>
                    <label className="block text-sm text-[#6b7a9a] mb-2">
                      Status (automatisch)
                    </label>
                    <div className="flex flex-col gap-1">
                      {roomModalDerivedOcc == null ? (
                        <span className="text-[#6b7a9a] text-sm">…</span>
                      ) : (
                        <Badge tone={getRoomOccBadgeTone(roomModalDerivedOcc)}>
                          {formatOccupancyStatusDe(roomModalDerivedOcc)}
                        </Badge>
                      )}
                      <p className="text-xs text-[#6b7a9a]">
                        Aus Mietverhältnissen (heute). Mieter und Ist-Miete: Mietvertrag.
                      </p>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm text-[#6b7a9a] mb-2">
                      Geplanter Mietpreis (CHF)
                    </label>
                    <input
                      type="number"
                      name="priceMonthly"
                      value={roomForm.priceMonthly}
                      onChange={onChange}
                      placeholder="z. B. 950"
                      className="w-full border border-black/10 dark:border-white/[0.08] rounded-[8px] px-4 py-3 bg-slate-100 dark:bg-[#111520] text-[#0f172a] dark:text-[#eef2ff] outline-none focus:ring-2 focus:ring-[#7aaeff]/40"
                    />
                    <p className="text-xs text-[#6b7a9a] mt-1">
                      Soll-Preis für Planung / Vollbelegung; keine Ist-Miete.
                    </p>
                  </div>

                  <div>
                    <label className="block text-sm text-[#6b7a9a] mb-2">
                      Mindestmietdauer in Monaten
                    </label>
                    <input
                      type="number"
                      name="minimumStayMonths"
                      value={roomForm.minimumStayMonths}
                      onChange={onChange}
                      min="1"
                      className="w-full border border-black/10 dark:border-white/[0.08] rounded-[8px] px-4 py-3 bg-slate-100 dark:bg-[#111520] text-[#0f172a] dark:text-[#eef2ff] outline-none focus:ring-2 focus:ring-[#7aaeff]/40"
                    />
                  </div>

                  <div>
                    <label className="block text-sm text-[#6b7a9a] mb-2">
                      Kündigungsfrist in Monaten
                    </label>
                    <input
                      type="number"
                      name="noticePeriodMonths"
                      value={roomForm.noticePeriodMonths}
                      onChange={onChange}
                      min="1"
                      className="w-full border border-black/10 dark:border-white/[0.08] rounded-[8px] px-4 py-3 bg-slate-100 dark:bg-[#111520] text-[#0f172a] dark:text-[#eef2ff] outline-none focus:ring-2 focus:ring-[#7aaeff]/40"
                    />
                  </div>
                </div>

                <div className="flex justify-end gap-3 mt-6">
                  <button
                    type="button"
                    onClick={onClose}
                    className="px-5 py-3 rounded-[8px] border border-black/10 bg-transparent text-[#64748b] hover:bg-black/[0.03] dark:border-white/[0.1] dark:text-[#8090b0] dark:hover:bg-white/[0.04]"
                  >
                    Abbrechen
                  </button>

                  <button
                    type="submit"
                    className="bg-gradient-to-r from-[#5b8cff] to-[#7c5cfc] text-white font-semibold rounded-[8px] border-none px-5 py-3 transition"
                  >
                    {editingRoomId
                      ? "Änderungen speichern"
                      : "Room speichern"}
                  </button>
                </div>
              </form>
            </div>
          </div>
  );
}
